export var createMuiMenuItemOverrides = function (_a) {
    var spacing = _a.spacing, palette = _a.palette;
    return ({
        root: {
            paddingTop: spacing(2),
            paddingBottom: spacing(2),
            color: palette.text.secondary,
            // MUI uses this for better mobile UX. It is set to `auto` on SM breakpoint
            // https://github.com/mui-org/material-ui/blob/151fa8155f1d63bf40174923e8d269f276f0b9b3/packages/material-ui/src/MenuItem/MenuItem.js#L11
            minHeight: spacing(8),
            "&$selected": {
                color: palette.text.primary,
            },
            "&&:hover, &&.Mui-focusVisible": {
                color: palette.text.secondary,
                backgroundColor: palette.action.hover,
            },
        },
        gutters: {
            paddingLeft: spacing(4),
            paddingRight: spacing(4),
        },
    });
};
//# sourceMappingURL=MuiMenuItem.js.map